<template>
  <div class="bb-total-card" @click="setFilterByTotal()">
    <h2 class="bb-total-card__title" @mouseleave="openPopup = false">
      {{title}}
      <i class="icon-info"
         v-if="info"
         @mouseenter="openPopup = true"></i>
    </h2>
    <div class="bb-total-card__icon"
         :class="{'bb-total-card__icon_checklist':icon === 'icon-checklist'}">
      <transition name="bounce">
        <ul class="bb-total-card-popup" v-if="openPopup">
          <li v-for="(elem, index) in info"
              :key="elem+index"
              class="bb-total-card-popup__elem-list">
          <span class="bb-total-card-popup__item">
            {{elem}}
          </span>
          </li>
        </ul>
      </transition>
      <i :class="icon"></i>
    </div>
    <div class="bb-total-card__sum"
         :class="'bb-total-card__sum_' + colorSum">
      <ICountUp
        :delay="countUp.delay"
        :endVal="sum ? sum : 0"
        :options="countUp.options"
        @ready="onReady"
      />
    </div>
  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'

export default {
  name: 'TotalCard',
  props: ['title', 'icon', 'sum', 'colorSum', 'info', 'filter'],
  components: {
    ICountUp
  },
  data: function () {
    return {
      openPopup: false,
      countUp: {
        delay: 0,
        options: {
          duration: 0.5,
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          decimalPlaces: 2
        }
      }
    }
  },
  methods: {
    setFilterByTotal () {
      if (!this.filter) return
      this.$emit('setFilter', this.filter)
    },
    onReady (instance, CountUp) {
      instance.update(this.sum)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-total-card {
    @include global-font;
    padding: 20px 15px 20px 20px;
    border-radius: 8px;
    background-color: $color-white;
    min-height: 109px;

    &__title {
      position: relative;
      color: $color-accent;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      height: 34px;

      i {
        color: $color-silver;
        cursor: pointer
      }
    }

    &__icon {
      position: relative;
      color: $color-accent;
      font-size: 36px;
      display: flex;
      justify-content: flex-end;

      &_checklist {
        font-size: 32px;
      }
    }

    &__sum {
      font-weight: 600;
      font-size: 18px;
      line-height: 21px;

      &_red {
        color: $color-red;
      }

      &_green {
        color: $color-limeade;
      }
    }

    &-popup {
      position: absolute;
      bottom: 60px;
      left: 130px;
      min-width: 97px;
      padding: 7px 12px;
      background-color: $color-white;
      list-style: disc inside;
      font-weight: normal;
      font-size: 11px;
      line-height: 17px;
      box-shadow: 0 0 20px rgba($color-black, 0.05);
      border-radius: 5px;
      z-index: 5;

      &__elem-list {
        white-space: nowrap;
      }

      &__item {
        margin-left: -7px;
      }

      &:after{
        content: '';
        position: absolute;
        left: 10px;
        top: 100%;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-top: 5px solid $color-white;
        box-shadow: 0 0 20px rgba($color-black, 0.1);
        clear: both;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/InvoiceTable/TotalCard/TotalCard.vue